import React from 'react';
import ClienteItem from './ClienteItem';

/**
 * Componente para mostrar una lista de clientes con espaciado óptimo
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Array} props.clientes - Lista de clientes a mostrar
 * @param {function} props.onEdit - Función para editar un cliente
 * @param {function} props.onDelete - Función para eliminar un cliente
 * @returns {JSX.Element} - Componente de lista de clientes
 */
const ClienteList = ({ clientes = [], onEdit, onDelete }) => {
  if (clientes.length === 0) {
    return (
      <div className="text-center p-4 bg-gray-800 rounded text-gray-400">
        No hay clientes registrados. Agrega uno para comenzar.
      </div>
    );
  }

  return (
    <div>
      <ul className="mt-4 space-y-3">
        {clientes.map(cliente => (
          <ClienteItem
            key={cliente.id}
            cliente={cliente}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ))}
      </ul>
    </div>
  );
};

export default ClienteList;